<template lang="pug">
nav.v-main-nav.main-nav(v-if="menu")
	.main-nav__grid
		.main-nav__banner(v-if="menu.banner && isSm")
			.menu-banner
				component.menu-banner__link(v-if="menu.banner"
						:is="menu.banner.link ? 'a' : 'button'"
						:href="menu.banner.link || undefined"
						@click="handleClick(menu.banner)")
				.menu-banner__text {{menu.banner.text}}
				img.menu-banner__image(v-if="isLoaded"
						:src="menu.banner.image"
						alt=""
						loading="lazy")
		.main-nav__cell
			template(v-if="menu.links")
				.main-nav__links
					template(v-for="(link, linkIndex) in menu.links" :key="linkIndex")
						a.main-nav__link.flc(:href="link.link")
							img.main-nav__link-icon(v-if="link.icon" :src="link.icon" alt="")
							.main-nav__link-text {{link.text}}
							v-svg-icon.main-nav__link-chevron(icon="menu-chevron-right")
			.main-nav__switchers.flc
				v-switchers
		.main-nav__right(v-if="menu.items && menu.items.length")
			.main-nav__right-grid
				template(v-for="(item, index) in menu.items" :key="index")
					.main-nav__right-cell
						template(v-if="item.type === 'button'")
							button.main-nav__item(type="button" @click="openModal(item)")
								v-svg-icon.main-nav__item-icon(v-if="item.icon" :icon="item.icon" alt="")
								.main-nav__item-text {{item.text}}
								v-svg-icon.main-nav__item-chevron(icon="menu-chevron-right")
						template(v-else)
							a.main-nav__item(:href="item.link" :target="item.target")
								v-svg-icon.main-nav__item-icon(v-if="item.icon" :icon="item.icon" alt="")
								.main-nav__item-text {{item.text}}
								v-svg-icon.main-nav__item-chevron(icon="menu-chevron-right")
				.main-nav__banner(v-if="menu.banner && !isSm")
					.menu-banner
						component.menu-banner__link(v-if="menu.banner"
								:is="menu.banner.link ? 'a' : 'button'"
								:href="menu.banner.link || undefined"
								@click="handleClick(menu.banner)")
						.menu-banner__text {{menu.banner.text}}
						img.menu-banner__image(v-if="isLoaded"
								:src="menu.banner.image"
								alt=""
								loading="lazy")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from './mixins/v-mixin-is-mob.vue';
import loadMixin from './mixins/v-load-mixin.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin,
		isMobMixin,
		loadMixin
	],

	data() {
		return {
			menu: null
		};
	},

	methods: {
		handleClick(banner) {
			if (!banner.link) {
				this.openModal(banner.callBack);
			}
		},

		openModal(item) {
			controller.openModal({
				className: 'modal--sm',
				component: {
					name: 'v-form',
					props: {
						dataSource: item.form,
						media: item.media,
						phones: item.phones,
						className: 'call-back'
					}
				}
			});
		},

		dataSet(data) {
			this.menu = data;
		}
	}
};
</script>